import * as actionTypes from './actionTypes'
import paymentService from 'services/paymentService'
import orderService from 'services/orderService'
import voucherService from "services/voucherService";
import { closeModalPlacedOrder } from './TeamVoucher';
import { CHECKOUT_OUTCOME, mapCheckoutError } from 'utils/checkoutError'
import { ERROR_CODES, knownError } from 'utils/userError'
import { orderPlacedMessage } from 'utils/orderConfirmation'
import { normalizeVoucherDiscounts } from 'utils/vouchers'


const isSuccessOrder = orderStatus => {
  return 'T' === orderStatus
}

const isFailureOrder = orderStatus => {
  return 'F' === orderStatus
}

const realexConfigDataLoaded = payload => {
  return {
    type: actionTypes.REALEX_CONFIG_DATA_LOADED,
    payload,
  }
}

const stripeConfigDataLoaded = payload => {
  return {
    type: actionTypes.STRIPE_CONFIG_DATA_LOADED,
    payload,
  }
}

const cartResetState = () => {
  return {
    type: actionTypes.CART_RESET_STATE,
  }
}

const menuResetState = () => {
  return {
    type: actionTypes.MENU_RESET_STATE
  }
}

const invoiceResetState = () => {
  return {
    type: actionTypes.INVOICE_RESET_STATE,
  }
}


const checkoutSetIntervalReference = (intervalReference) => {
  return {
    type: actionTypes.CHECKOUT_SET_INTERVAL_REFERENCE,
    payload: intervalReference,
  }
}

export const checkoutResetState = () => {
  return {
    type: actionTypes.CHECKOUT_RESET_STATE,
  }
}

export const resizeRealexForm = size => {
  return {
    type: actionTypes.CHECKOUT_RESIZE_REALEX_FORM,
    payload: size,
  }
}

export const openModalReceipt = () => dispatch => {
  dispatch(closeModalPlacedOrder())
  dispatch({
    type: actionTypes.CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_RECEIPT,
    payload: true,
  })
}

export const closeModalReceiptAndRedirect = history => dispatch => {
  dispatch(checkoutResetState())
  dispatch(cartResetState())
  dispatch(menuResetState())
  history.replace('/Menu')
}

export const closeModalError = () => {
  return {
    type: actionTypes.CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR,
    payload: { show: false, messageError: '' },
  }
}

export const openModalError = messageError => {
  return {
    type: actionTypes.CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR,
    payload: { show: true, messageError: messageError }
  }
}

export const closeModalErrorAndRedirect = history => dispatch => {
  dispatch(checkoutResetState())
  dispatch(cartResetState())
  dispatch(menuResetState())
  dispatch(invoiceResetState())
  history.replace('/Menu')
}

export const openModalPlaceOrder = message => {
  return {
    type: actionTypes.CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_PLACE_ORDER,
    payload: { show: true, messageSuccess: message },
  }
}

export const closeModalPlaceOrderAndRedirect = history => dispatch => {
  dispatch(checkoutResetState())
  dispatch(cartResetState())
  dispatch(invoiceResetState())
  dispatch(menuResetState())
  history.replace('/Menu')
}

export const getRealexConfig = realexConfigRequestDTO => {
  return dispatch => {
    paymentService
      .getRealexConfig(realexConfigRequestDTO).then(payload => {
        dispatch(realexConfigDataLoaded(payload))
      })
      .catch(err => {
        console.log(err)
      })
  }
}

export const getStripeConfig = stripeConfigRequestDTO => {
  return dispatch => {
    paymentService
      .getStripeConfig(stripeConfigRequestDTO).then(payload => {
        dispatch(stripeConfigDataLoaded(payload))
      })
      .catch(err => {
        console.log(err)
      })
  }
}

export const loopCheckingPaymentResponse = payload => {
  return dispatch => {
    if (payload.isInvoice) {
      dispatch(checkInvoice(payload))
    } else {
      dispatch(checkOrder(payload))
    }
  }
}

const checkOrder = (payload) => dispatch => {
  let attempts = 0
  const intervalReference = setInterval(() => {
    orderService.getOrderStatus(payload.idOrder)
      .then(_payload => {
        if (isSuccessOrder(_payload.orderStatus)) {
          clearInterval(intervalReference)
          dispatch(consumeVoucher(payload.payInfo))
          dispatch(openModalPlaceOrder(orderPlacedMessage(
            payload.payInfo && payload.payInfo.publicOrderNumber
          )))
          dispatch(checkoutSetIntervalReference(undefined))
        } else if (isFailureOrder(_payload.orderStatus) && attempts > 4) {
          clearInterval(intervalReference)
          dispatch(openModalError(knownError(ERROR_CODES.PAYMENT_DECLINED, {
            title: "Your payment didn't go through",
            message: 'The order was not paid, so it is not confirmed.',
            guidance: 'Try again, or choose another payment method.',
          })))
          dispatch(checkoutSetIntervalReference(undefined))
        }
        attempts++
      })
      .catch(err => {
        console.log(err)
      })
  }, 1500)
  dispatch(checkoutSetIntervalReference(intervalReference))
}


export const successPayOrder = payload => {
  return {
    type: actionTypes.SUCCESS_PLACE_ORDER,
    payload: {
      idOrder: payload.idOrder,
      isInvoice: false,
      descriptionSuccess: orderPlacedMessage(payload.publicOrderNumber)
    },
  }
}

export const consumeVoucher = payload => {

  return dispatch => {
    const vouchers = normalizeVoucherDiscounts(payload && payload.discounts)
    if (vouchers.length === 0) {
      return Promise.resolve()
    }

    const confirmVoucher = payload.payType === 'A'
    const voucher = {
      idOrder: payload.idOrder,
      totalOrder: payload.total,
      confirmVoucher: confirmVoucher,
      vouchers: vouchers
    };
    return voucherService
      .consume(voucher)
      .catch(err => {
        dispatch(triggerModalErrorPlacedOrder(err, {
          outcome: CHECKOUT_OUTCOME.CONFIRMED,
          orderNumber: payload.publicOrderNumber,
          postOrderFailure: true,
        }));
      });
  };
};

export const triggerModalErrorPlacedOrder = (error, context) => {
  return {
    type: actionTypes.TRIGGER_MODAL_ERROR_PLACED_ORDER,
    checkoutError: mapCheckoutError(error, context)
  };
};

const checkInvoice = payload => dispatch => {
  if (payload.messageRealex.startsWith("Error: 501")) {
    dispatch(openModalError(knownError(ERROR_CODES.PAYMENT_ALREADY_PROCESSED, {
      title: 'This invoice has already been paid',
      message: `The payment for invoice ${payload.idOrder} was processed earlier.`,
      guidance: "If you think this is wrong, contact support with the reference below. Don't pay again.",
    })))
  } else {
    let attempts = 0
    const intervalReference = setInterval(() => {
      orderService.getInvoiceStatus(payload.idOrder)
        .then(data => {
          if (data.invoiceStatus === "R") {
            clearInterval(intervalReference)
            dispatch(openModalPlaceOrder(`Thank You - Your payment has been accepted. Invoice Confirmed! Invoice Number: ${payload.idOrder}`))
            dispatch(checkoutSetIntervalReference(undefined))
          } else if ((data.invoiceStatus === 'F' || data.invoiceStatus === '0') &&
            attempts > 4) {
            clearInterval(intervalReference)
            dispatch(openModalError(knownError(ERROR_CODES.PAYMENT_DECLINED, {
              title: "Your invoice payment didn't go through",
              message: 'The invoice was not paid.',
              guidance: 'Try again, or choose another payment method.',
            })))
            dispatch(checkoutSetIntervalReference(undefined))
          }
          attempts++
        })
        .catch(err => {
          console.log(err)
        })
    }, 1500)
    dispatch(checkoutSetIntervalReference(intervalReference))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/Checkout.js